var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NativeInterfaceAbstractCommunication } from "./NativeInterfaceAbstractCommunication";
var NativeInterfaceTransmit = /** @class */ (function (_super) {
    __extends(NativeInterfaceTransmit, _super);
    function NativeInterfaceTransmit(eventRouter) {
        var _this = _super.call(this, eventRouter) || this;
        window.nativeInterfaceListener = function (event) {
            // console.log('Receive from native: ', event);
            _this.onCommunicationReceived(event);
        };
        return _this;
    }
    NativeInterfaceTransmit.prototype.call = function (event) {
        if (typeof window.native !== 'undefined') {
            // console.log('Send to native: ', event);
            var status_1 = window.native.transmit(JSON.stringify(event));
            if (status_1 === 'OK')
                return true;
            return false;
        }
        else if (window.webkit !== undefined
            && window.webkit.messageHandlers !== undefined
            && window.webkit.messageHandlers.nativeBridge !== undefined) {
            window.webkit.messageHandlers.nativeBridge.postMessage(JSON.stringify(event));
            return true;
        }
        else {
            return false;
        }
    };
    return NativeInterfaceTransmit;
}(NativeInterfaceAbstractCommunication));
export { NativeInterfaceTransmit };
//# sourceMappingURL=NativeInterfaceTransmit.js.map